import React, { ReactNode, useRef } from 'react'
import useSticky from 'core/hooks/useSticky'
import Button from 'core/components/buttons/Button'
import Icon from 'core/components/icons/Icon'
import { AnimatePresence, motion } from 'framer-motion'

interface ListHeaderProps {
  children: ReactNode
}

const ListHeader = ({ children }: ListHeaderProps) => {
  const headerRef = useRef<HTMLDivElement>(null)
  const isSticky = useSticky(0, headerRef)

  return (
    <div
      ref={headerRef}
      className="sticky top-0 z-10 py-4 px-6 bg-white shadow-sm"
    >
      <AnimatePresence>
        <div className="flex items-center justify-between">
          <motion.p
            className="text-sm text-dark-4"
            animate={{
              scale: isSticky ? 1.1 : 1,
              fontWeight: isSticky ? 500 : 400
            }}
            transition={{ duration: 0.2 }}
          >
            {children}
          </motion.p>

          {isSticky && (
            <motion.div
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 20 }}
              transition={{ duration: 0.2 }}
            >
              <Button
                variant="link"
                className="text-primary"
                onClick={() => {
                  window.open(
                    'https://help.everlance.com/hc/en-us/articles/8100561283981-Product-Update-Log',
                    '_blank'
                  )
                }}
                suffix={<Icon name="open" noWrapper />}
              >
                Changelog
              </Button>
            </motion.div>
          )}
        </div>
      </AnimatePresence>
    </div>
  )
}

export default ListHeader
